import { show as showNiceModal } from '@ebay/nice-modal-react'
import { StoreInstances } from '../store/StoreInstancesContainer'
import { MiscPreferencesKeys } from '../store/user/UserStore'
import { PartTypeModal } from '../ui-components/modals/PartTypeModel'
import { parseBoolean } from '../ui-components/util/CommonFunctions'
import history from './history'
import { isValidSearchText } from './isValidSearchText'
import { NonCachedSearchType } from 'interfaces'
import { InterchangeBreadcrumbAction } from '../store/models/SearchModels'

export const getInterchangeParts = (
  text: string,
  breadcrumbAction: InterchangeBreadcrumbAction = 'replace',
  maxLength = 14
): void => {
  if (!isValidSearchText(text, maxLength)) return
  // MPV3-7765: prevent a user firing off the same search numerous times in a short timeframe.
  if (
    StoreInstances.searchStore.lastNonCachedSearch ===
      NonCachedSearchType.searchByInterchange &&
    StoreInstances.searchStore.lastInterchangeTextSearched === text &&
    StoreInstances.searchStore.isLoading
  ) {
    return
  }

  const isInterchangePartTypes =
    StoreInstances.userStore.miscPreferences[
      MiscPreferencesKeys.INTERCHANGE_PARTTYPES
    ] && false // MPV3-5810 - temporary disabled drawers - Nov 13th 2024, to get them back remove the '&& false'
  const isInterchangeManufacturersTypes =
    StoreInstances.userStore.miscPreferences[
      MiscPreferencesKeys.INTERCHANGE_MANUFACTURERS
    ] && false // MPV3-5810 - temporary disabled drawers - Nov 13th 2024, to get them back remove the '&& false'
  if (parseBoolean(isInterchangePartTypes)) {
    showNiceModal(PartTypeModal, {
      title: 'interchangeSearch',
      subtitle: text,
      modeltype: 'PartType',
    })
  } else if (parseBoolean(isInterchangeManufacturersTypes)) {
    showNiceModal(PartTypeModal, {
      title: 'interchangeSearch',
      subtitle: text,
      modeltype: 'Manufacture',
    })
  } else {
    const trimmedText = text.trim()
    StoreInstances.uiStore.setSkipAddVehicleCallback(undefined)

    const search = () =>
      StoreInstances.searchStore.getInterchangeApiRequest(
        trimmedText,
        [],
        [],
        '',
        parseBoolean(
          StoreInstances.userStore.miscPreferences?.[
            MiscPreferencesKeys.INTERCHANGE_PARTTYPES
          ]
        ),
        parseBoolean(
          StoreInstances.userStore.miscPreferences?.[
            MiscPreferencesKeys.INTERCHANGE_MANUFACTURERS
          ]
        ),
        breadcrumbAction
      )

    // When already on searchResults, stamp the current history entry with
    // the current search state so back button can restore it.
    if (window.location.pathname === '/searchResults') {
      const { searchStore } = StoreInstances
      const currentState = window.history.state ?? {}
      window.history.replaceState(
        {
          ...currentState,
          usr: {
            ...(currentState.usr ?? {}),
            restoreSearch: {
              type: searchStore.lastNonCachedSearch,
              text: searchStore.lastTextSearched,
              interchangeText: searchStore.lastInterchangeTextSearched,
            },
          },
        },
        ''
      )
    } else {
      // Navigating from outside the results page (e.g. Home) — start a fresh
      // breadcrumb trail so the previous search doesn't bleed through.
      StoreInstances.searchStore.cleanBreadCrumbs()
    }

    search()
    history.navigate('/searchResults')
  }
}
